module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("(Adicione os documentos referentes ao item abaixo)")]), _vm._v(" "), (!_vm.showGrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo de documento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4 col-lg-3",
    attrs: {
      "for": "tipo de documento"
    }
  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [(_vm.editando) ? _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documento.tipo_documento.ds_tipo),
      expression: "documento.tipo_documento.ds_tipo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.documento.tipo_documento.ds_tipo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.documento.tipo_documento, "ds_tipo", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documento.tipo_documento),
      expression: "documento.tipo_documento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "tipo de documento",
      "id": "tipo de documento",
      "disabled": _vm.desativado || _vm.editando
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.documentos), function(tipoDocumento) {
    return _c('option', {
      key: _vm.documento.id,
      domProps: {
        "value": tipoDocumento
      }
    }, [_vm._v(_vm._s(tipoDocumento.ds_tipo))])
  }), 0)]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'tipo_documento') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "#048019"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'tipo_documento') && _vm.ocultaIcone === false) ? _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.tipo_documento.ds_tipo + '</h5>'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('arquivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4 col-lg-3",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [(_vm.editando) ? _c('div', [_c('a', {
    staticClass: "ng-binding",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.onDownload(_vm.documento)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.documento.ds_nome_arquivo))])]) : _c('div', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        size: _vm.tamanhoPermitido,
        mimes: _vm.tiposPermitidos
      }),
      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "name": "arquivo",
      "id": "file",
      "disabled": _vm.desativado
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })])]), _vm._v(" "), (_vm._.hasIn(_vm.mudancas, 'ds_nome_arquivo') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
    staticClass: "col-md-2 fa-lg"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "6px",
      "margin-left": "-50px",
      "color": "#048019"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'ds_nome_arquivo') && _vm.ocultaIcone === false) ? _c('div', {
    staticClass: "col-md-2 fa-lg"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "6px",
      "margin-left": "-50px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.ds_nome_arquivo + '</h5>'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Vigencia')
    },
    attrs: {
      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
    }
  }, [_c('div', {
    staticClass: "col-md-16"
  }, [(_vm._.hasIn(_vm.mudancas, 'dt_data_vigencia') && _vm.ocultaIcone === false && _vm._.isEmpty(_vm.conteudoAnterior)) ? _c('div', {
    staticClass: "col-md-2 fa-lg"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "-10px",
      "color": "#048019"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm._.hasIn(_vm.conteudoAnterior, 'dt_data_vigencia') && _vm.ocultaIcone === false) ? _c('div', {
    staticClass: "col-md-2 fa-lg"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "-10px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.conteudoAnterior.dt_data_vigencia + '</h5>'
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-10 col-md-offset-3"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-add"
    },
    on: {
      "click": _vm.adicionaDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.editando) ? _c('span', [_vm._v("Ok")]) : _c('span', [_vm._v("Adicionar Documento")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showGrid) ? _c('div', [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "myField",
      "name": "myField",
      "value": ""
    }
  }), _vm._v(" "), (!_vm.disable) ? _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), (_vm.faseProposta !== 'FORMALIZACAO' && _vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO') ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.propDocumentos.length < _vm.maxFiles) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novoDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo documento ")]) : _vm._e(), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        placement: 'right',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "1px",
      "color": "#048019"
    },
    attrs: {
      "title": '<h5>Inclusões: ' + _vm.inclDocTexto + '</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("  Houve a inserção de novo(s) documento(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true && _vm.mostraExclusao) ? _c('div', [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        placement: 'right',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "1px",
      "color": "#808080"
    },
    attrs: {
      "title": '<h5>Exclusões: ' + _vm.excDocTexto + '</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("  Houve a exclusão de documento(s)")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('thead', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v("Arquivo")]), _vm._v(" "), _c('td', [_vm._v("Inclusão")]), _vm._v(" "), (!_vm.disable) ? _c('td', [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documentTypes), function(pendente) {
    return (!_vm.existeDocumento(pendente)) ? _c('tr', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('td', [_vm._v(_vm._s(pendente.ds_tipo))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [(!_vm.disable) ? _c('button', {
      staticClass: "btn btn-primary btn-sm btn-flat btn-block",
      staticStyle: {
        "max-width": "135px",
        "text-align": "center"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onAddFile(pendente)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                  Adicionar arquivo\n                ")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.propDocumentos), function(documento, indexDocumento) {
    return _c('tr', {
      key: indexDocumento,
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "value": documento
      }
    }, [(documento.tipo_documento) ? _c('td', [_vm._v(_vm._s(documento.tipo_documento.ds_tipo))]) : _c('td'), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "ng-binding",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.onDownload(documento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(documento.ds_nome_arquivo))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(documento.dt_criado, 'DD/MM/YYYY')))]), _vm._v(" "), (!_vm.disable) ? _c('td', [(!_vm.disable && !_vm.PropProrrogacaoEdit) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
        expression: "faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
      }],
      staticClass: "btn btn-primary btn-sm btn-flat",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editaDocumento(documento, indexDocumento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.disable && !_vm.PropEditandoAlteracaoProjeto) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.faseProposta !== 'FORMALIZACAO' && _vm.faseProposta !== 'APROVACAO_PROJETO' && _vm.faseProposta !== 'APROVACAO'),
        expression: "faseProposta !== 'FORMALIZACAO' && faseProposta !== 'APROVACAO_PROJETO' && faseProposta !== 'APROVACAO'"
      }, {
        name: "confirm",
        rawName: "v-confirm",
        value: ({
          ok: function (retorno) { return _vm.deletaDocumento(indexDocumento); },
          cancel: _vm.doNothing,
          message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'
        }),
        expression: "{ok: retorno => deletaDocumento(indexDocumento), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> a documento ' + documento.ds_nome_arquivo + ' ?'}"
      }],
      staticClass: "btn btn-danger btn-sm btn-flat",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-offset-1 fa-lg"
    }, [(_vm._.hasIn(_vm.atualizados, indexDocumento)) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          placement: 'left'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
      }],
      staticClass: "fa fa-warning",
      staticStyle: {
        "position": "relative",
        "top": "8px",
        "margin-left": "2px",
        "color": "#fb2916"
      },
      attrs: {
        "title": '<h5>Clique em editar para ver as mudanças.</h5>'
      }
    }) : _vm._e()])]) : _vm._e()])
  })], 2)])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pendente")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-80f95162!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/uploadCotacaoManual.vue
// module id = 2035
// module chunks = 1